import {BlockBasic} from '../_models/models.js';

/**
 *  Table block
 */
export default class BlockTable extends BlockBasic {
    constructor(block) {
        super(block);
        this.type = 'table';
        this.size.width = 1200;
        this.size.height = 600;
        this.protection.type = ['table'];
        this.data = {
            html: '',
            headerColor: 'lightgrey',  // Default color
            cellPadding: [10, 10, 10, 10],
            paddingLocked: true,
            borderStyle: 'solid',  // Default table border style
            borderThickness: 2,   // In px
            borderColor: "rgb(0, 0, 0)"
        };
    }
}
